import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PackingFormComponent} from "../packing-form/packing-form.component";
import {appInjector} from "../../../index";
import {Product} from "../../../shared/view-model/store-management/product.type";
import {ManufacturerInputFieldComponent} from "../../../crm/manufacturer/manufacturer-input-field/manufacturer-input-field.component";
import {ManufacturerService} from "../../../crm/services/manufacturer.service";


@Component({
  selector: 'vb-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ProductFormComponent)}]
})
export class ProductFormComponent extends AbstractVisbosControl<Product, FormGroup> implements OnInit {

  //@HostBinding('class')
  //private classBinding = 'form';

  public setDefaultValues(item?: Product): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name'),
      default_product: this.setValue(item, 'default_product')
    }
  };

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, private manufacturerService: ManufacturerService) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(values?: Product, ...params): FormGroup {
    return ProductFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    let ctrl = fb.group({
      cuid: [null, Validators.required],
      name: [null],
      default_product: [null],
      packings: fb.array([], Validators.required),
      manufacturer: ManufacturerInputFieldComponent.initControl(fb),
      supplier_id: [null, Validators.required],
    });

    return ctrl;
  }


  addPacking() {
    let pkgCtrl: FormArray = <FormArray>this.control.get('packings');
    pkgCtrl.push(PackingFormComponent.initControl(this.fb));
  }

  deletePacking(id: number) {
    let pkgCtrl: FormArray = <FormArray>this.control.get('packings');
    pkgCtrl.removeAt(id);
  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/product/product-form/product-form.component.ts